// Kalahari Rose - Add to Cart Popup v2
// Intercepts button click (capture phase) before Prestige theme handler fires
(function() {
  'use strict';
  if (!window.location.pathname.match(/^\/products\//)) return;

  function createModal() {
    var style = document.createElement('style');
    style.textContent = [
      '#kr-cart-modal { display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 99999; align-items: center; justify-content: center; }',
      '#kr-cart-modal.active { display: flex; }',
      '#kr-cart-modal-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.45); cursor: pointer; }',
      '#kr-cart-modal-box { position: relative; background: #fff; padding: 44px 40px; text-align: center; max-width: 420px; width: 90%; border-radius: 2px; box-shadow: 0 12px 48px rgba(0,0,0,0.18); }',
      '#kr-cart-modal-icon { font-size: 28px; margin-bottom: 12px; color: #5a8a5a; }',
      '#kr-cart-modal-title { font-size: 15px; color: #2c2c2c; margin: 0 0 8px; letter-spacing: 0.08em; text-transform: uppercase; font-weight: 600; }',
      '#kr-cart-modal-subtitle { font-size: 13px; color: #888; margin: 0 0 28px; letter-spacing: 0.02em; }',
      '#kr-cart-modal-buttons { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }',
      '#kr-continue-btn, #kr-checkout-btn { display: inline-block; padding: 14px 22px; font-size: 11px; letter-spacing: 0.14em; font-weight: 700; text-decoration: none; text-transform: uppercase; cursor: pointer; transition: all 0.2s ease; min-width: 155px; }',
      '#kr-continue-btn { border: 1.5px solid #2c2c2c; color: #2c2c2c; background: transparent; }',
      '#kr-continue-btn:hover { background: #2c2c2c; color: #fff; }',
      '#kr-checkout-btn { background: #2c2c2c; color: #fff; border: 1.5px solid #2c2c2c; }',
      '#kr-checkout-btn:hover { background: #111; border-color: #111; }',
      '#kr-cart-modal-close { position: absolute; top: 14px; right: 18px; background: none; border: none; font-size: 20px; color: #aaa; cursor: pointer; line-height: 1; padding: 4px 8px; }',
      '#kr-cart-modal-close:hover { color: #333; }'
    ].join('');
    document.head.appendChild(style);

    var modal = document.createElement('div');
    modal.id = 'kr-cart-modal';
    modal.innerHTML = '<div id="kr-cart-modal-overlay"></div><div id="kr-cart-modal-box"><button id="kr-cart-modal-close" aria-label="Close">&times;</button><div id="kr-cart-modal-icon">&#10003;</div><p id="kr-cart-modal-title">Added to Cart</p><p id="kr-cart-modal-subtitle">What would you like to do next?</p><div id="kr-cart-modal-buttons"><a id="kr-continue-btn" href="/pages/shop">Continue Shopping</a><a id="kr-checkout-btn" href="/checkout">Checkout</a></div></div>';
    document.body.appendChild(modal);
    document.getElementById('kr-cart-modal-overlay').addEventListener('click', hideModal);
    document.getElementById('kr-cart-modal-close').addEventListener('click', hideModal);
    return modal;
  }

  var modal = null;
  function showModal() { if (!modal) modal = createModal(); modal.classList.add('active'); document.body.style.overflow = 'hidden'; }
  function hideModal() { if (modal) modal.classList.remove('active'); document.body.style.overflow = ''; }
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') hideModal(); });

  // Intercept add-to-cart button click in CAPTURE phase
  // This fires before the Prestige theme's own click handler
  document.addEventListener('click', function(e) {
    var btn = e.target.closest ? e.target.closest('.ProductForm__AddToCart, [data-action="add-to-cart"]') : null;
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;
    var action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Disable button to prevent double-click
    btn.disabled = true;
    var origText = btn.innerHTML;
    btn.innerHTML = '<span>Adding...</span>';

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        btn.disabled = false;
        btn.innerHTML = origText;
        if (data.id || data.items) {
          showModal();
        } else {
          // Item out of stock or error
          form.submit();
        }
      })
      .catch(function() {
        btn.disabled = false;
        btn.innerHTML = origText;
        form.submit();
      });
  }, true);

})();
